import { useMemo } from 'react';

import { getArray } from 'utils/helpers';
import Tooltype from 'components/Tooltip';
import style from 'pages/ProfileOrders/OrdersCard/OrdersProduct/style.module.scss';

const AttributesList = ({ attributes }) => {
  return (
    <div className={style.specifications}>
      <h2>Specifications</h2>
      <ul>
        {attributes.map((attr) => (
          <li key={attr.key}>
            <h3>{attr.key}</h3>
            <div>{attr.value}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const styles = {
  tooltip: {
    padding: '10px 12px',
    margin: '10px 0!important',
    backgroundColor: '#fff',
    maxWidth: '50vw',
    boxShadow: '0px 2px 14px rgba(0, 0, 0, 0.1)',
    borderRadius: 4,
    color: '#2D3543',
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '16px',
  },
  tooltipPlacementTop: {
    borderBottom: '4px solid #3360ad',
  },
  tooltipPlacementBottom: {
    borderTop: '4px solid #3360ad',
  },
  popperArrow: {
    '&[x-placement*="top"] .MuiTooltip-arrow': {
      bottom: -2,
    },
    '&[x-placement*="bottom"] .MuiTooltip-arrow': {
      top: -2,
    },
  },
  arrow: {
    color: '#3360ad',
  },
};

const AttributesTooltype = ({ attributes, Wrapper = 'span' }) => {
  const attrs = useMemo(() => {
    const visible = getArray(attributes)
      .slice(0, 3)
      .map((a) => `${a.value.slice(0, 20)}${a.value.length > 20 ? '...' : ''}`);

    if (getArray(attributes).length > 3) {
      visible.push('...');
    }
    return visible.join(', ');
  }, [attributes]);

  return (
    <Tooltype
      styles={styles}
      placement={'top'}
      arrow
      interactive
      title={<AttributesList attributes={getArray(attributes).slice(0, 3)} />}
    >
      <Wrapper>{attrs}</Wrapper>
    </Tooltype>
  );
};

export default AttributesTooltype;
